export default "__VITE_ASSET__BGm7lzyu__"